export interface IFindDsdResult {
    id: number,
    donorName: string,
    donorEmail: string,
    donorBirthDate: string,
    registrationDate: string
}